import { render, staticRenderFns } from "./AppMenuFolderEditModal.vue?vue&type=template&id=5e375293"
import script from "./AppMenuFolderEditModal.vue?vue&type=script&lang=js"
export * from "./AppMenuFolderEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports